import { render } from "./DepositAppLesotho.vue?vue&type=template&id=bbaa6b86&scoped=true"
import script from "./DepositAppLesotho.vue?vue&type=script&lang=js"
export * from "./DepositAppLesotho.vue?vue&type=script&lang=js"

import "./DepositAppLesotho.vue?vue&type=style&index=0&id=bbaa6b86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaa6b86"]])

export default __exports__